import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/subdistricts/form'
import { api, actionCreators } from 'store/modules/subdistricts'

const metadata = {
  icon: 'flag-o',
  page: 'subdistricts',
  dialogSize: dialogSizes.MD
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
